// src/store/purchaseModalManagment/types.ts
//
// État du raccourci d'achat de quota créateur : « Acheter » ouvre directement le
// choix du moyen de paiement, sans passer par l'onglet Achats (le panier existe
// toujours côté serveur — un seul article y est ajouté avant l'ouverture de cette
// fenêtre — mais l'utilisateur ne le voit jamais).

export const OPEN_PURCHASE_MODAL  = 'OPEN_PURCHASE_MODAL';
export const CLOSE_PURCHASE_MODAL = 'CLOSE_PURCHASE_MODAL';

export interface PurchaseModalState {
  open  : boolean;
  cartId: number | null;
  amount: number;  // centimes, TTC — cart.amount après ajout de l'article
  label : string;  // nom du produit, transmis en description du paiement
}

export const initialState: PurchaseModalState = {
  open  : false,
  cartId: null,
  amount: 0,
  label : '',
};

export interface OpenPurchaseModalAction {
  type: typeof OPEN_PURCHASE_MODAL;
  payload: {
    cartId: number;
    amount: number;
    label : string;
  };
}

export interface ClosePurchaseModalAction {
  type: typeof CLOSE_PURCHASE_MODAL;
}

export type PurchaseModalActionTypes =
  | OpenPurchaseModalAction
  | ClosePurchaseModalAction;
